module.exports = __webpack_public_path__ + "img/logo95decibels.6917d98.svg";